// Recovered compiled webpack factory 40579. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "parseRelativeUrl", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }));
  let n = r(62296),
    a = r(33078);
  function o(e, t, r) {
    void 0 === r && (r = !0);
    let o = new URL((0, n.getLocationOrigin)()),
      i = t ? new URL(t, o) : e.startsWith(".") ? new URL(window.location.href) : o,
      { pathname: s, searchParams: l, search: u, hash: c, href: f, origin: d } = new URL(e, i);
    if (d !== o.origin)
      throw Object.defineProperty(
        Error("invariant: invalid relative URL, router received " + e),
        "__NEXT_ERROR_CODE",
        { value: "E159", enumerable: !1, configurable: !0 },
      );
    return {
      pathname: s,
      query: r ? (0, a.searchParamsToUrlQuery)(l) : void 0,
      search: u,
      hash: c,
      href: f.slice(d.length),
      slashes: void 0,
    };
  }
}
